"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageContext = void 0;
var _react = require("react");
var PageContext = /*#__PURE__*/(0, _react.createContext)({});
exports.PageContext = PageContext;